import { ReactNode, SVGProps } from 'react';
import { cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { FontColorType, getFontColorClassName } from '../helpers';
import { IconStyles } from './Icon.styles';

export type IconProps = SVGProps<SVGSVGElement> & {
  children?: ReactNode;
  size?: number;
  color?: FontColorType;
};

export const Icon = ({
  children,
  color,
  focusable,
  fill,
  viewBox,
  size = 24,
  noFill,
  className,
  ...props
}: IconProps & { noFill?: boolean }) => {
  return (
    <svg
      className={cx(
        IconStyles.icon,
        noFill ? IconStyles.iconNoFill : IconStyles.iconFill,
        color ? getFontColorClassName(color) : undefined,
        className
      )}
      style={{
        minWidth: size,
        fontSize: theme.fontSize(size),
      }}
      focusable={focusable ?? false}
      width={size}
      height={size}
      aria-hidden={props['aria-hidden'] ?? true}
      {...props}
      viewBox={viewBox}
    >
      {children}
    </svg>
  );
};
